import {
  GENERAL_TICKETS,
  GENERAL_TICKETS_ERROR,
  CLEAN_GENERAL_TICKETS,
  CLEAN_GENERAL_TICKETS_ERROR,
} from '_models/redux/types';

const initialState = {
  loaded: undefined,
  method: undefined,
  payload: undefined,
  status: undefined,
  state: undefined,
};

export default function generalTicketsReducer(state = initialState, action) {
  switch (action.type) {
    case GENERAL_TICKETS:
      return {
        ...state,
        loaded: true,
        method: action?.method || null,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'success',
      };

    case GENERAL_TICKETS_ERROR:
      return {
        ...state,
        loaded: true,
        payload: action?.payload || {},
        status: action?.status || null,
        state: 'error',
      };

    case CLEAN_GENERAL_TICKETS:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'success',
      };

    case CLEAN_GENERAL_TICKETS_ERROR:
      return {
        ...state,
        loaded: false,
        payload: action?.payload || undefined,
        status: undefined,
        state: 'error',
      };
    default:
      return state;
  }
}
